import type { PageLoad } from "./$types";
import { redirect } from "@sveltejs/kit";
import { mainPagePath } from "../../support/links";
import { onWelcome } from "../../domain/announcements";

export const load: PageLoad = async function ({ parent }) {
  const { announcements, events, heraldSchedule, heraldHomePage, settings } = await parent();

  if (heraldHomePage == null) {
    redirect(307, mainPagePath(settings));
  }

  return {
    announcements: onWelcome(announcements),
    schedule: heraldSchedule,
    events: events,
    homepage: heraldHomePage,
    settings: settings,
    pageTitle: settings.homeTitle || heraldHomePage.name,
    pageDescription: settings.homeDescription,
    pageTheme: heraldHomePage.backgroundColor
  };
};
